import { all } from "redux-saga/effects";
import { profileFetchWatcher } from "../../auth-saga/profileFtech-saga";
import { loginWatcher, logoutWatcher } from "../../auth-saga/auth-saga";

export default function* AuthRootSaga() {
  yield all([loginWatcher(),profileFetchWatcher(),logoutWatcher()]);
}
